import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { createPanelSlice, type PanelSlice } from '~/components/v2/store/shared/createPanelSlice';
import {
  createWorkspaceSidebarResizingSlice,
  type WorkspaceSidebarResizingSlice,
} from '~/components/v2/store/shared/createWorkspaceSidebarResizingSlice';
import { ZustandStorageKeys } from '~/constants/zustandStorageKeys';

export type WorkspaceSidebarState = PanelSlice & WorkspaceSidebarResizingSlice;

export const useWorkspaceSidebarStore = create<WorkspaceSidebarState>()(
  persist(
    (set, get, store) => ({
      ...createPanelSlice({ open: true })(set, get, store),
      ...createWorkspaceSidebarResizingSlice()(set, get, store),
    }),
    {
      name: ZustandStorageKeys.WorkspaceSidebar,
      partialize: (state) => ({
        open: state.open,
      }),
      version: 1,
    },
  ),
);
